import React from "react";
import PropTypes from "prop-types";
import {
  setColourShade,
  SIGNOL_COLOUR_NAMES_WITH_SHADES,
} from "@signolteam/shared/colours";
import Loader from "@src/components/atoms/Loader";
import Tooltip from "@src/components/atoms/Tooltip";
import AppUtils from "@src/utils/appUtils";
import CardContainer from "@src/components/cards/CardContainer";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

const ManagerDashboardInfo = ({
  text,
  value,
  behaviourColour = "primary",
  highlight = false,
  isLoading = false,
  tooltipContent = undefined,
}) => {
  return (
    <CardContainer
      bgColor={setColourShade(behaviourColour, 100)}
      shadow={false}
      {...(tooltipContent?.length > 0
        ? { allowOverflow: true, zIndex: 10 }
        : {})}
    >
      {isLoading && !text ? (
        <div className="p-5">
          <Loader size="sm" />
        </div>
      ) : (
        <div className="flex gap-3 justify-between">
          <div
            className={`flex ${
              highlight ? "flex-col-reverse" : "flex-col"
            } p-5 ${tooltipContent ? "pr-0" : ""}`}
          >
            <span className={`text-${behaviourColour}-500 text-sm`}>
              {text}
            </span>
            <span
              className={
                highlight
                  ? "text-black text-3xl md:text-4xl font-medium"
                  : `text-${behaviourColour}-800`
              }
            >
              {isLoading ? <Loader size="sm" inline /> : value?.toString()}
            </span>
          </div>
          {tooltipContent && (
            <div onClick={(e) => e.stopPropagation()} className="pt-5 pr-5">
              <Tooltip
                content={tooltipContent}
                direction={"down-left"}
                absolute={false}
              />
            </div>
          )}
        </div>
      )}
    </CardContainer>
  );
};

export const managerDashboardInfoControls = {
  text: {
    propType: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    description: "Card text content",
    disable: true,
  },
  value: {
    propType: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        toString: PropTypes.func,
      }),
    ]),
    description: "Display value",
    disable: true,
  },
  highlight: {
    propType: PropTypes.bool,
    description: "Highlight styling",
    controlType: "boolean",
    defaultValue: false,
  },
  behaviourColour: COMMON_CONTROLS.colour_name_shaded,
  isLoading: COMMON_CONTROLS.isLoading,
};
ManagerDashboardInfo.propTypes = AppUtils.getPropTypeFromControls(
  managerDashboardInfoControls,
);

export default ManagerDashboardInfo;
